module.exports = __webpack_public_path__ + "static/logo-0fa96afa0f95eef68725043a51f5f894.png";